module.exports = __webpack_public_path__ + "img/this thing rips.32a2a434.png";